export interface EnvConfig {
    baseUrl: string;
    authIssuer: string;
    authClientId: string;
    useMockData: boolean;
    publicAPIVersion: string;
    publicAPIClientType: string;
    logging?: boolean;
}

const baseConfig = {
    publicAPIVersion: "4.19",
    publicAPIClientType: "ServiceApp",
    authIssuer: "https://identity-s.trumpf.com",
    authClientId: process.env.CLIENT_SECRET_QA as string
};

const envConfigs: {
    [key: string]: EnvConfig;
} = {
    dev: {
        ...baseConfig,
        baseUrl: "https://api.qa.mytbs.trumpf.com",
        useMockData: true,
        logging: true
    },
    devLegacy: {
        ...baseConfig,
        baseUrl: "https://api.mytrumpf.com.qa.tru",
        useMockData: true,
        logging: true
    },
    qa: {
        ...baseConfig,
        baseUrl: "https://api.qa.mytbs.trumpf.com",
        useMockData: false
    },
    qaLegacy: {
        ...baseConfig,
        baseUrl: "https://api.mytrumpf.com.qa.tru",
        useMockData: false
    },
    prod: {
        ...baseConfig,
        baseUrl: "https://api.mytbs.trumpf.com",
        authIssuer: "https://identity.trumpf.com",
        authClientId: process.env.CLIENT_SECRET_PROD as string,
        useMockData: false
    },
    prodLegacy: {
        ...baseConfig,
        baseUrl: "https://api.mytrumpf.com",
        authIssuer: "https://identity.trumpf.com",
        authClientId: process.env.CLIENT_SECRET_PROD as string,
        useMockData: false
    }
};
let env: string = "prod";
export const authClientName = "service-cases";

/**
 * get config for a specific environment
 * @param environment any custom env string (optional - will use env set by setEnv otherwise)
 * @returns config object
 */
export const getEnvConfig = (environment?: string): EnvConfig => {
    return envConfigs[environment || env];
};

/**
 * set the current environment (used for getEnvConfig)
 * @param environment any custom env string
 */
export const setEnv = (environment: string) => {
    if (!envConfigs[environment]) {
        // eslint-disable-next-line no-console
        console.error(`Environment ${environment} not found`);
        return;
    }
    env = environment;
};
